import * as React from 'react';

import {
    DUE_UNIT_HOURS_ID,
    DUE_UNIT_DAYS_ID,
    DUE_UNIT_BUSINESS_DAYS_ID,
    DUE_UNIT_WEEKS_ID,
    DUE_UNIT_MONTHS_ID,
    DUE_UNIT_MINUTES_ID,
} from 'nutshell-core/date-time/delays';
import type {DueDateUnit as DelayUnit} from 'nutshell-core/types';

import {SelectPickerGeneric} from '../select-picker-generic/select-picker-generic';
import {TextField} from '../textfield/textfield';

import styles from './delay-input.module.css';

type Props = {
    customOptions?: {
        label: string;
        value: string;
    }[];
    onSelectChange: (selection: DelayUnit) => void;
    selectedOption: DelayUnit;
    onInputChange: (value: number) => void;
    inputValue: number;
};

export function DelayInput(props: Props) {
    // Options for the select picker
    const options = props.customOptions || [
        {
            label: props.inputValue === 1 ? 'Minute' : 'Minutes',
            value: DUE_UNIT_MINUTES_ID,
        },
        {
            label: props.inputValue === 1 ? 'Hour' : 'Hours',
            value: DUE_UNIT_HOURS_ID,
        },
        {
            label: props.inputValue === 1 ? 'Day' : 'Days',
            value: DUE_UNIT_DAYS_ID,
        },
        {
            label: props.inputValue === 1 ? 'Business day' : 'Business days',
            value: DUE_UNIT_BUSINESS_DAYS_ID,
        },
        {
            label: props.inputValue === 1 ? 'Week' : 'Weeks',
            value: DUE_UNIT_WEEKS_ID,
        },
        {
            label: props.inputValue === 1 ? 'Month' : 'Months',
            value: DUE_UNIT_MONTHS_ID,
        },
    ];

    // Styles for the select picker
    const selectStyles = {
        // @ts-expect-error
        control: (base) => ({...base, height: '100%'}),
    } as const;

    // Handler for input change
    // @ts-expect-error
    const handleInputChange = (value) => {
        const val = parseInt(value);
        // Validate input - only numbers allowed
        if (typeof val === 'number') {
            props.onInputChange(val ? val : 0);
        }
    };

    // Handler for select change
    // @ts-expect-error
    const handleSelectChange = (selection) => {
        props.onSelectChange(selection.value);
    };

    return (
        <div className={styles.container}>
            <TextField
                // @ts-expect-error
                className='textfield'
                placeholder='0'
                type='number'
                min='0'
                max='365'
                value={props.inputValue ? props.inputValue.toString() : ''}
                onChange={handleInputChange}
                hasError={props.inputValue === 0}
                selectOnFocus={true}
            />
            <SelectPickerGeneric
                options={options}
                isSearchable={false}
                value={
                    props.selectedOption.length
                        ? options.find((obj) => {
                              return obj.value === props.selectedOption;
                          })
                        : options[1]
                }
                onChange={handleSelectChange}
                styles={selectStyles}
            />
        </div>
    );
}
